import RNPrint from 'react-native-print';
import moment from 'moment';
import {Platform} from 'react-native';

export default async function CheckinGRC(dat: any, dat1: any) {
  let html = `<html><head><meta charset="utf-8">
  <style>
    @page { size: A4; margin: 0.5cm; }
    img { width:100%; max-width:300px; height:100%; max-height:100px; }
    .invoice-box { max-width: 800px; margin: auto; padding: 30px; border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15); font-size: 14px; line-height: 24px;
    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif; color: #555; }
    table { width: 100%; line-height: inherit; text-align: left; border-collapse: collapse; }
    td { padding: 5px; vertical-align: top; }
    .heading td { background: #eee; border-bottom: 1px solid #ddd; font-weight: bold; }
    .item td { border-bottom: 1px solid #eee; }
    .total td:nth-child(5) { border-top: 2px solid #eee; font-weight: bold; }
  </style></head><body>
  <div class="invoice-box">
  <table>
    <tr class="top">
      <td colspan="4">
        <table>
          <tr>
            <td>${dat1.cm_logo ? `<img src="${dat1.cm_logo}" alt="Logo" />` : `<b>${dat1.cm_name || ''}</b>`}</td>
            <td style="text-align:right">
              <b>${dat1.cm_name}</b><br/>
              ${dat1.cm_addr1}<br/>
              ${dat1.cm_addr2},
              ${dat1.cm_addr3}<br/>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr><td colspan="4" style="border-top:1px solid black; border-bottom:1px solid black; text-align:center"><b>GRC</b></td></tr>
    <tr><td>GRC #:</td><td>${dat.data.gr_no}</td><td>Date</td><td>${moment(
    dat.data.ci_date,
    'YYYY/MM/DD HH:mm:ss',
  ).format('DD-MMM-YY HH:mm:ss')}</td></tr>
    <tr><td>Folio #:</td><td>${dat.data.ci_no}</td><td>Source</td><td>${
    dat1.sr_name
  }</td></tr>
    <tr><td>Mobile</td><td>${dat.data.ab_mobile}</td><td>Company</td><td>${
    dat.data.ab_cname
  }</td></tr>
    <tr><td>Name</td><td colspan="3">${dat.data.ab_name}</td></tr>
    <tr><td>Address</td><td colspan="3">${dat.data.ab_addr1}<br/>${
    dat.data.ab_addr2
  }<br/>${dat.data.ab_city} - ${dat.data.ab_pincode}</td></tr>
    <tr><td>Arrival</td><td>${moment(
      dat.data.ci_arrvial,
      'YYYY/MM/DD HH:mm:ss',
    ).format('DD-MMM-YY HH:mm')}</td><td>Departure</td><td>${moment(
    dat.data.ci_depature,
    'YYYY/MM/DD HH:mm:ss',
  ).format('DD-MMM-YY HH:mm')}</td></tr>
    <tr><td>Days</td><td colspan="3">${dat.data.ci_days}</td></tr>
    <tr><td>Advance Amount</td><td>₹ ${Number(dat.data.ci_advamt).toFixed(
      2,
    )}</td><td>Receipt No</td><td>${dat.data.ci_rcptno}</td></tr>
    <tr><td>Advance Mode</td><td>${dat1.ci_mode}</td><td></td><td></td></tr>
    <tr><td colspan="4">
      <table>
        <tr class="heading">
          <td>S. #</td><td>Description</td><td>Room No</td>
          <td style="text-align:right">Male</td><td style="text-align:right">Female</td>
          <td style="text-align:right">Child</td><td style="text-align:right">Rate</td>
          <td style="text-align:right">Amount</td>
        </tr>`;

  dat.data.ci_details?.forEach(element => {
    const roomType =
      dat1.cm_roomtype.find(v => v.id === element.cd_roomtype)?.label || '';
    const roomName =
      dat1.cm_room.find(v => v.rm_id === element.cd_room)?.rm_name || '';
    html += `<tr class="item">
      <td>${element.cd_srid + 1}</td>
      <td>${roomType}</td>
      <td>${roomName}</td>
      <td style="text-align:right">${element.cd_male}</td>
      <td style="text-align:right">${element.cd_female}</td>
      <td style="text-align:right">${element.cd_child}</td>
      <td style="text-align:right">${element.cd_rate}</td>
      <td style="text-align:right">${element.cd_amt}</td>
    </tr>`;
  });

  html += `</table>
    </td></tr>
    <tr><td colspan="4" style="font-size: 12px;"><ul>
      <li>Proof of identity is required at check-in.</li>
      <li>Checkout after 16:00 may incur charges.</li>
      <li>Room tariff excludes transfer and additional charges.</li>
      <li>Bill to be settled at checkout; no personal checks accepted.</li>
      <li>Inform smoking preference in advance, subject to availability.</li>
    </ul></td></tr>
    <tr><td>Receptionist</td><td>GM</td><td>Accounts</td><td style="text-align:right">Guest Sign</td></tr>
    <tr><td colspan="4" style="text-align:center">Thank You, Visit Us Again</td></tr>
  </table>
  </div></body></html>`;

  if (Platform.OS === 'web') {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  } else {
    await RNPrint.print({html});
  }
}

